import { prioridadeInfo } from "../../../utils/solicitacoes/statusConfig";

// Retorna null quando o processo não tem prioridade (só Solicitação de Compras tem hoje).
export default function PrioridadeBadge({ prioridade }) {
    const info = prioridadeInfo(prioridade);
    if (!info) return null;

    return (
        <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${info.className}`}>
            {info.label}
        </span>
    );
}
